import { Factory } from 'rosie';

Factory.define('FbMessengerUserId');

Factory.define('FbMessengerUserIdWithDefaults')
  .extend('FbMessengerUserId')
  .attr('pageId', 'example-page-id')
  .attr('userId', 'example-user-psid');
